// The Shop tab until the catalogue lands (005): the categories as Live Colour Tiles, marked
// "Coming soon" and not pressable, so every tile on Home leads somewhere that keeps the world's colour.
// No invented products or prices (PRODUCT.md, Evidence on Hand).
import { Link } from "expo-router";
import { ScrollView, StyleSheet, View } from "react-native";

import { useChromeKind } from "@/shell/chrome/useChromeKind";
import { makeStyles } from "@/theme/makeStyles";
import { Button } from "@/ui/Button";
import { Text } from "@/ui/Text";

import { Tile } from "./HomeScreen";
import { BookStackArt, PencilArt, ShirtArt } from "./TileArt";

export const SHOP_COPY = {
  title: "Shop",
  lead: "Coming soon. Your school's booklist and stationery will be here.",
  soon: "Coming soon",
  home: "Go to Home",
} as const;

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    scroll: { flex: 1, backgroundColor: t.color.background },
    page: {
      width: "100%",
      maxWidth: 1080,
      alignSelf: "center",
      paddingHorizontal: t.space.lg,
      paddingTop: t.space.lg,
      paddingBottom: t.space.x3l,
      gap: t.space.sm,
    },
    intro: { gap: t.space.xs, marginBottom: t.space.md },
    row: { flexDirection: "row", gap: t.space.sm },
    action: { marginTop: t.space.lg, alignSelf: "flex-start", minWidth: 200 },
  }),
);

export function ShopScreen() {
  const styles = useStyles();
  const wide = useChromeKind() === "desktop";
  const books = (
    <Tile
      testID="shop-books"
      label="School books"
      caption={SHOP_COPY.soon}
      fill="tileAmber"
      ink="onTileAmber"
      Art={BookStackArt}
    />
  );
  const stationery = (
    <Tile
      testID="shop-stationery"
      label="Stationery"
      caption={SHOP_COPY.soon}
      fill="tileGreen"
      ink="onTile"
      Art={PencilArt}
    />
  );
  const uniforms = (
    <Tile
      testID="shop-uniforms"
      label="Uniforms"
      caption={SHOP_COPY.soon}
      fill="tileMuted"
      ink="onTileMuted"
      Art={ShirtArt}
    />
  );
  return (
    <ScrollView style={styles.scroll} testID="placeholder-shop">
      <View style={styles.page} role="main">
        <View style={styles.intro}>
          <Text variant="display" accessibilityRole="header" aria-level={1}>
            {SHOP_COPY.title}
          </Text>
          <Text tone="muted">{SHOP_COPY.lead}</Text>
        </View>
        {wide ? (
          <View style={styles.row}>
            {books}
            {stationery}
            {uniforms}
          </View>
        ) : (
          <>
            <View style={styles.row}>
              {books}
              {stationery}
            </View>
            <View style={styles.row}>{uniforms}</View>
          </>
        )}
        <View style={styles.action}>
          <Link href="/" asChild>
            <Button variant="outline" accessibilityRole="link">
              {SHOP_COPY.home}
            </Button>
          </Link>
        </View>
      </View>
    </ScrollView>
  );
}
